import React from 'react';
import styled from 'styled-components';

const StyledTableCell = styled.div`
  display: table-cell;
  border-top: solid 1px #ebebeb !important;
  color: #333333 !important;
  width: 186px;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 186px;
  padding: 12px 0 12px 16px !important;
  font-size: 14px;
  text-align: left;
  position: relative;
`;

const StyledSpan = styled.span`
  margin-left: 48px;
  position: relative;
`;

const StyledImg = styled.img`
  display: inline-block;
  position: absolute;
  top: -3px;
  left: -43px;
  width: 28px;
`;

const StyledDiv = styled.div`
  font-size: 14px;
`;

interface Props {
  image?: string;
  value: any;
  isWide: boolean;
}

export const InquiryListItemFacility = (props: Props) => {
  const { image, value, isWide } = props;

  return isWide ? (
    <StyledTableCell>
      <StyledSpan>
        <StyledImg alt="" src={image}></StyledImg>
        {value}
      </StyledSpan>
    </StyledTableCell>
  ) : (
    <StyledDiv>{value}</StyledDiv>
  );
};
